(function (){
    var noticeListTmpl =
        '<li class="lists notice" data-noticeid="{{ noticeId }}" data-noticetype="{{ noticeType }}">' +
        '<div class="head">' +
        '<a href="{{ link }}" class="qna-item">' +
        '<span class="badge active notice">공지</span>' +
        '<span class="inquiry-type"></span>'+
        //BTOCSITE-46481
        '<div class="title-box">' +
        '<span class="title"><em class="blind">공지글 제목</em>{{ noticeTitle }}</span>' +
        '</div>' +
        '<div class="info-wrap">' +
        '<span class="date"> <em class="blind">작성일</em>{{ creationDate }} </span>' +
        '</div>' +
        '</a>' +
        '</div>' +
        '</li>';
//    BTOCSITE-26021 - 옵션 구조 추가
    var qnaListTmpl =
        '<li class="lists" data-que-no="{{ questionNo }}" data-secret-flag="{{secret}}" data-current-flag="{{currentSecret}}" data-blocked="{{blocked}}">' +
        '<div class="head">' +
        '<a href="{{#if ((secret == "N") && (blocked == "N")) || ((secret == "Y") && (blocked == "N") && (sameId == "Y")) }}{{ link }}{{/if}}{{#if (secret == "N") || (blocked == "N") || (sameId == "N") }}#{{/if}}" class="qna-item{{#if (secret == "Y") && (blocked == "N") }} off{{/if}}{{#if (blocked == "Y") }} hide{{/if}}">' +
        '<span class="badge {{#if (answered == "Y") }}active{{/if}}"><em class="blind">문의 진행 상태</em>{{#if (answered == "Y") }}답변완료{{/if}}{{#if (answered == "N") }}답변대기{{/if}}</span>' +
        '<span class="inquiry-type"><em class="blind">문의 카테고리</em>{{ questionTypeName }}</span>'+
        '<div class="title-box">' +
        '<h4 class="title-info">{{ modeloptinfostr }}</h4>'+
        '<span class="title">' +
        '<em class="blind">문의글 제목</em>{{#if (secret == "Y") && (blocked == "N") && (sameId == "N") }}<em class="blind">비밀글</em>{{/if}}{{#if (secret == "Y") && (blocked == "N") && (sameId == "N") }}비밀글입니다.{{#else}}{{ questionTitle }}{{/if}}' +
        '</span>' +
        '</div>' +
        '<div class="info-wrap">' +
        '<span class="writer"><em class="blind">작성자</em>{{ creationUserName }}</span>' +
        '<span class="date"><em class="blind">작성일</em>{{ creationDate }}</span>' +
        '</div>' +
        '</a>' +
        '</div>' +
        '</li>';


    var KRP0043 = {
        init : function (){
            loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
            cphn = commonData.hasOwnProperty("userInfo") && commonData.userInfo.cphn ? commonData.userInfo.cphn : ""; // BTOCSITE-84481 [상품셀영향도] 디지털 데이터 수정 건

            var self = this;
            var componentChk = document.getElementById("pdp_qna"); //BTOCSITE-11299 추가

            vcui.require(['ui/pagination', 'ui/validation'], function (){
                self.settings();
                self.bindEvents();
                self.validation = new vcui.ui.Validation('#submitForm', {});

                //BTOCSITE-11299 componentChk 분기처리 추가 - Q&A component 존재할 경우에만 API 실행
                if(!componentChk) {
                    console.log("not found QnA component!")
                } else {
                    // BTOCSITE-13901 : 보유제품 UI 개선 
                    if(self.$qnaListWrap.length) {
                        self.requestTypeCode(function(questionTypeCode){
                            if(questionTypeCode === 'HOW_TO_USE') $('#orderType').val(questionTypeCode).vcSelectbox('update')

                            var excludePrivate = $("#secretSort").is(":checked") ? "Y" : "N";
                            var myQna = $("#myWriteView").is(":checked") ? "Y" : "N";
                            var typeCode = questionTypeCode;

                            if($("select#orderType option").val() && $("select#orderType option").length > 1) {
                                typeCode = $('#orderType').val();
                            }

                            self.requestQnaListData({
                                "questionTypeCode": typeCode,
                                "excludePrivate": excludePrivate,
                                "myQna": myQna,
                                "page": "1",
                                "init":true
                            }, false);
                        });
                    } else {
                        if(self.$KRP0043.find('.qna-list-wrap').hasClass('type-detail')) $('#pdp_qna').addClass('show');
                    }
                }
            });
        },
        settings : function (){
            var self = this;
            self.$KRP0043 = $('.KRP0043');

            // 단독 qna 페이지 전용
            self.$qnaWrap = $('.qnaWrap');

            // QnA 리스트 상단 영역
            self.$sortingWrap = self.$KRP0043.find('.sorting-wrap');
            self.$sortSelect = self.$sortingWrap.find('.ui_selectbox'); //문의유형 select 정렬
            self.$sortSecChk = self.$sortingWrap.find('.chk-wrap'); //비밀글 제외 체크 
            self.$reqBtn = self.$KRP0043.find('.btn-inquiry'); //문의하기 버튼

            //Qna LIst
            self.$dataModelId = self.$KRP0043.attr('data-model-id');
            self.$qnaListWrap = self.$KRP0043.find('.qna-list-wrap').not('.type-detail');
            self.$qnaList = $('ul.qna-result-lists');
            self.appendCount = 0;

            self.$modifyBtn = self.$KRP0043.find('.modi-btn');
            self.$deleteBtn = self.$KRP0043.find('.del-btn');

            self.$nodata = self.$KRP0043.find('.no-data-message');
            self.$pagination = self.$KRP0043.find('.pagination').vcPagination({scrollTop : 'noUse'});

            //등록하기 팝업
            self.$writePopup = $('#popupWrite')
            self.$writeForm = self.$writePopup.find("#submitForm");
            self.$writeFormFileItem = self.$writeForm.find(".file-item");

            self.$writeQnaType = self.$writePopup.find('#qnaType');
            self.$writeTitle = self.$writePopup.find('#title');
            self.$writeDesc = self.$writePopup.find('#content');

            self.$secretChkBtn = self.$writePopup.find('#privateFlag');

            self.$btnFileUpload = self.$writePopup.find('.btn-file-upload'); // 사진/동영상 첨부 버튼

            self.$cphnView = self.$writePopup.find('#cphnView');
            self.$cphnReg = self.$writePopup.find('#cphnReg');
        },
        bindEvents : function() {
            var self = this;

            // QnA 리스트 : 페이징 선택
            self.$pagination.off('page_click.page').on('page_click.page',  function(e, data) {
                var questionTypeCode = self.$sortSelect.vcSelectbox('value');
                var excludePrivate = $('#secretSort').closest(".chk-wrap").find('input[type=checkbox]:checked').val(); // on , undefined(not-checked) 
                var myQna = $('#myWriteView').closest(".chk-wrap").find('input[type=checkbox]:checked').val();// on , undefined(not-checked) 
                if(excludePrivate === "on" ) {
                    excludePrivate = "Y";
                } else {
                    excludePrivate = "N";
                }
                if(myQna === "on" ) {
                    myQna = "Y";
                } else {
                    myQna = "N";
                }
                self.requestQnaListData({"questionTypeCode":questionTypeCode,"excludePrivate":excludePrivate ,"myQna":myQna,"page": data});
            });

            // QnA 리스트 : selectbox 선택
            self.$sortSelect.off('change').on('change', function(e){
                var questionTypeCode = self.$sortSelect.vcSelectbox('value');
                var excludePrivate = $('#secretSort').closest(".chk-wrap").find('input[type=checkbox]:checked').val(); // on , undefined(not-checked) 
                var myQna = $('#myWriteView').closest(".chk-wrap").find('input[type=checkbox]:checked').val();// on , undefined(not-checked) 
                excludePrivate = excludePrivate === "on" ? "Y" : "N";
                myQna = myQna === "on" ? "Y" : "N";
                self.requestQnaListData({"questionTypeCode":questionTypeCode,"excludePrivate":excludePrivate ,"myQna":myQna,"page": "1"});
            });

            // 닫기 버튼 클릭 시 form 전체 입력 값 초기화
            self.$writePopup.off('click', '.btn-close').on('click', '.btn-close', function(){
                $("#submitForm")[0].reset();
            });

            // 비밀글 제외 체크
            self.$KRP0043.find('#secretSort').off('click').on('click', function(){
                var questionTypeCode = self.$sortSelect.vcSelectbox('value');
                var excludePrivate = $('#secretSort').closest(".chk-wrap").find('input[type=checkbox]:checked').val(); // on , undefined(not-checked)
                var myQna = $('#myWriteView').closest(".chk-wrap").find('input[type=checkbox]:checked').val();// on , undefined(not-checked) 
                excludePrivate = excludePrivate === "on" ? "Y" : "N";
                myQna = myQna === "on" ? "Y" : "N";
                self.requestQnaListData({"questionTypeCode":questionTypeCode,"excludePrivate":excludePrivate ,"myQna":myQna,"page": "1"});
            });

            // 내 문의 보기 체크
            self.$KRP0043.find('#myWriteView').off('click').on('click', function(){
                if(lgkorUI.stringToBool(loginFlag)) {
                    var questionTypeCode = self.$sortSelect.vcSelectbox('value');
                    var excludePrivate = $('#secretSort').closest(".chk-wrap").find('input[type=checkbox]:checked').val(); // on , undefined(not-checked)
                    var myQna = $('#myWriteView').closest(".chk-wrap").find('input[type=checkbox]:checked').val();// on , undefined(not-checked) 
                    excludePrivate = excludePrivate === "on" ? "Y" : "N";
                    myQna = myQna === "on" ? "Y" : "N";
                    self.requestQnaListData({"questionTypeCode":questionTypeCode,"excludePrivate":excludePrivate ,"myQna":myQna,"page": "1"});
                } else {
                    $('#myWriteView').prop("checked", false);
                    lgkorUI.confirm('', {
                        title:'로그인 후 등록이 가능합니다.<br>로그인 하시겠습니까?',
                        okBtnName: '예',
                        cancelBtnName: '아니오',
                        ok : function (){
                            window.location.href = "/sso/member/login";
                        }
                    }, $('#myWriteView')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 내 문의 보기 팝업 close 시 포커스 이동
                }
            });

            self.$writePopup.find('.btn-confirm').off('click').on('click', function() {

                var param = $(this).closest("#popupWrite").data('param');
                var valChk = self.formValidationChk(param);
                if(valChk){
                    lgkorUI.confirm('', {
                        title:param.mode === 'write' ? '저장 하시겠습니까?' : '게시물을 수정하시겠습니까?',
                        okBtnName:param.mode === 'write' ? '확인' : '예',
                        cancelBtnName:param.mode === 'write' ? '취소' :'아니오',
                        ok: function() {
                            if(param.mode === 'write'){
                                self.requestQnaWrite(param);
                            }else{
                                self.requestQnaModify(param);
                            }
                        }
                    }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                }
            });

            // qna 리스트 선택시, 비밀글 alert 처리
            self.$qnaList.off('click', '.qna-item').on('click', '.qna-item', function(e){
                var $list = $(this).closest('li');
                var secretFlag = $list.data("secretFlag");
                var currentFlag = $list.data("currentFlag");
                var blocked = $list.data("blocked");

                if(secretFlag == "Y" && blocked == "N" && currentFlag == "N") {
                    e.preventDefault();
                    lgkorUI.alert("", {
                        title: '비밀글은 작성자만 조회할  수 있습니다.',
                        okBtnName : '확인'
                    }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동

                    return;
                }
            })

            //삭제하기
            self.$qnaList.off('click', '.del-btn').on('click', '.del-btn', function(){
                var modelId = $('.KRP0043').attr('data-model-id');
                var queNo = $(this).closest('li.lists').attr("data-que-no");
                lgkorUI.confirm('', {
                    title:'게시물을 삭제하시겠습니까? <br> 답변이 작성된 경우 답변도 같이 삭제됩니다.',
                    cancelBtnName: '아니오', okBtnName: '예',
                    ok : function (){
                        self.requestQnaDelete({"modelId":modelId, "queNo":queNo});
                    }
                }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
            })

            //문의하기 
            self.$reqBtn.off('click').on('click', function(){
                var mode = self.$reqBtn.attr('data-name');
                //console.log(mode);
                self.requestQnaReadPop({"mode":mode, "selector":this}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동

            });

            //수정하기
            $('.qna-result-lists').off('click', '.modi-btn').on('click', '.modi-btn', function(){
                var mode = $(this).attr('data-name');
                var modelId = self.$dataModelId;
                var queNo = $(this).closest('li.lists').attr("data-que-no");
                self.requestQnaReadPop({"mode":mode,"selector":this, "modelId":modelId, "queNo":queNo}); //qna read popup
            });

            //qna 상세 비디오
            if(self.$qnaWrap.find('.content-video')) {
                var $btnVideo = self.$qnaWrap.find('.content-video .btn-video');

                $btnVideo.filter('.sound').off('click').on('click', function(){
                    var $targetVideo = $(this).closest('.content-video').find('video');

                    if($(this).hasClass('is-sound')){
                        $(this).removeClass('is-sound');
                        $(this).addClass('is-muted');

                        $targetVideo.attr('muted', false);
                    } else {
                        $(this).removeClass('is-muted');
                        $(this).addClass('is-sound');

                        $targetVideo.attr('muted', true);
                    }
                })

                $btnVideo.filter('.play').off('click').on('click', function(){
                    var $targetVideo = $(this).closest('.content-video').find('video');

                    if($(this).hasClass('is-play')){
                        $(this).removeClass('is-play');
                        $(this).addClass('is-pause');

                        $targetVideo[0].play();
                    } else {
                        $(this).removeClass('is-pause');
                        $(this).addClass('is-play');

                        $targetVideo[0].pause();
                    }
                })
            }

            // 사진/동영상 첨부
            self.$btnFileUpload.on('click', function(){
                self.$writeFormFileItem.filter(':not(.on)').find('.btn-upload').eq(0).click();
            });

            // 첨부파일 input이 변경될 경우 사진/동영상 첨부 버튼 disabled 처리
            self.$writeFormFileItem.find('input[type="file"]').off('change').on('change', function(e){
                setTimeout(function(){
                    if(self.$writeFormFileItem.filter(':not(.on)').length > 0){
                        self.$btnFileUpload.prop('disabled', false);
                    } else {
                        self.$btnFileUpload.prop('disabled', true);
                    }
                }, 100);
            })
        },
        itemAccordionEnabledChk: function(item){
            if( item.blocked == "Y" ) {
                this.enabled = "N";
            } else {
                this.enabled = "Y";
                if( item.secret == "Y" ) {
                    this.enabled = item.sameId == "Y" ? "Y" : "N"
                } else {
                    this.enabled = "Y"
                }
            }

            return this.enabled
        },
        itemCurrentSecretCheck: function(item){
            if(item.sameId == "Y" && item.secret == "Y") {
                this.currentSecret = "Y"
            } else {
                this.currentSecret = "N";
            }

            return this.currentSecret;
        },

        checkImgFileFormat: function(file) {
            var optArr = "jpg|jpeg|png|gif".split('|'),
                formatArr = file.fileName.split('.'),
                format = formatArr[formatArr.length - 1].toLowerCase();

            if (!vcui.array.has(optArr, format)) {
                return false;
            }

            return true;
        },

        // BTOCSITE-13901 : 보유제품 UI 개선
        // qna default question type 
        requestTypeCode: function(callback){
            var self = this;
            var ajaxUrl = self.$KRP0043.data('countAjax');
            
            if(ajaxUrl) {
                lgkorUI.requestAjaxDataPost(ajaxUrl, {
                    modelId :  self.$dataModelId,
                    questionTypeCode : 'HOW_TO_USE',
                    excludePrivate : 'N',
                    myQna : 'N'
                }, function(result){
                    var questionTypeCode = (result.status === 'success' && result.data > 0) ? 'HOW_TO_USE' : 'ALL';
                    if(callback && typeof callback === 'function') callback(questionTypeCode);
                });
            } else {
                if(callback && typeof callback === 'function') callback('ALL');

            }
        },

        // qna-list - get
        requestQnaListData : function(param, showsLoading){
            //console.log("QnA List - API request !!");
            //console.log(param);

            var self = this;
            var ajaxUrl = self.$KRP0043.data('ajax') + "?modelId=" + self.$dataModelId + "&page=" + param.page ;
            var selectedQTypeVal = param.questionTypeCode;
            var $activeElement = $(document.activeElement) // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 문의하기 페이징 이동 후 포커스 이동
            var isPaginationClick = $activeElement.closest('.pagination').length; // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 문의하기 페이징 이동 후 포커스 이동

            $('#orderType').val(selectedQTypeVal).vcSelectbox('update')

			if (showsLoading === undefined || showsLoading) {
				lgkorUI.showLoading();
			}
			
            lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
                var listData = result.data.qnaList;
                var noticeData = result.data.qnaNoticeList;
                var innerHTML = "";

                var pagination = result.data.pagination;

                //BTOCSITE-40636
                var totalCount = result.data.qnaTotalCount;
                if(result.status == "success"){

                    if( (noticeData.length > 0 && listData.length > 0) || listData.length > 0 || noticeData.length > 0) {
                        self.$KRP0043.removeClass('no-data');

                        noticeData.forEach(function(item){
                            innerHTML += vcui.template(noticeListTmpl, item);
                        });
                        listData.forEach(function(item){
                            item.enabled = self.itemAccordionEnabledChk(item);
                            item.currentSecret = self.itemCurrentSecretCheck(item);
                            innerHTML += vcui.template(qnaListTmpl, item);
                        });

                        // 211206 추가 - 필터. no-data일경우에,비노출 처리 건, 다시 데이터 조회될 경우, 초기화
                        if(self.$qnaWrap.length) {
                            self.$qnaListWrap.find(self.$qnaList).empty().append(innerHTML);
                        } else {
                            self.$qnaListWrap.filter('.is-pc').find(self.$qnaList).empty().append(innerHTML);
                            // if(self.appendCount == 0) {
                                self.$qnaListWrap.filter('.is-mobile').find(self.$qnaList).empty().append(innerHTML);
                                if(self.$qnaListWrap.filter('.is-mobile').find(self.$qnaList).find('li').length < 4) {
                                    self.$KRP0043.addClass('small-list');
                                }
                                // self.appendCount++;
                            // }
                        }
                        self.$KRP0043.find('.qna-result-lists').show();
                        self.$nodata.hide();
                        self.$pagination.vcPagination('setPageInfo', pagination);
                        lgkorUI.hideLoading();
                        // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 문의하기 페이징 이동 후 포커스 이동
                        if (isPaginationClick) {
                            self.$KRP0043.find('.qna-result-lists').find('a, button, input').first().focus();
                        }
                        // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 문의하기 페이징 이동 후 포커스 이동
                    } else {
                        self.$KRP0043.addClass('no-data');
                        self.requestNoData();
                        self.$pagination.vcPagination('setPageInfo', pagination);

                    }
                    //BTOCSITE-40636
                    $('.ta-c').find('.count').text('('+totalCount+')');
                } else {
                    self.$KRP0043.addClass('no-data');
                    self.requestNoData();
                    self.$pagination.vcPagination('setPageInfo', pagination);

                }

                // 보유 제품 과 pdp 에서 no-data 처리 차이 수정
                var isManageProduct = location.href.indexOf('/my-page/manage-products-detail') > -1 ? true : false; // 보유제품 페이지 체크 변수
                if((isManageProduct && !self.$KRP0043.hasClass('no-data')) || !isManageProduct)  {
                    if( param.init && !$('#pdp_qna').hasClass('show')) {
                        $('#pdp_qna').addClass('show');
                    }
                } 
                //success end
            });

        },
        // qna-read-popup - get
        requestQnaReadPop : function(param) {
            //console.log("QnA 조회 팝업 - API request !!");
            var self = this;

            //수정하기용, 문의하기일땐 READ API거칠 필요 없음
            //console.log("param.mode", param.mode)
            var paramCheck = param.mode == "write" ?  "" : "?modelId=" + param.modelId +"&questionNo="+ param.queNo;
            var ajaxUrl = self.$KRP0043.data('readAjax') + paramCheck;

            //일반 case
            if(lgkorUI.stringToBool(loginFlag)) {

                var qTypeList = self.$writeQnaType.find('option');
                var qTypeBtnSelectedText = $("#type_desc .ui-selectbox-wrap").find('.ui-selectbox-view > a > .ui-select-text');
                var uploadInputFiles = $('.ui_imageinput').find('input[type="file"]');
                $('input[type=file]').removeData('fileFlag');

                // BTOCSITE-60581 휴대폰 번호 추가 (답변 알림톡)
                if(!!cphn.trim()){
                    self.$cphnView.val(cphn.replace(/[^0-9]/g, "").replace(/(^02|^050[0-9]|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-****-$3").replace("--", "-"));
                    self.$cphnReg.closest('div').remove();
                }else{
                    self.$cphnView.closest('div').remove();
                }
                if(param.mode == 'write') {
                    // write
                    self.$writeTitle.val('');
                    self.$writeDesc.val('');
                    //self.$secretChkBtn.attr("checked",true); BTOCSITE-69476 "비밀글로 문의하기"의 디폴트를 체크 해제된 상태로 변경요망

                    // 함수 추가 - 211207 
                    self.fileHideCheck();

                    self.$writePopup.find('.pop-header > .tit > span').html("문의하기");
                    qTypeBtnSelectedText.html("문의유형 선택");
                    //qTypeList.eq(0).addClass("on");

                    if(self.$writePopup.hasClass='modify') {
                        self.$writePopup.removeClass('modify');
                    }
                    self.$writePopup.addClass(param.mode);

                    self.$reqBtn.attr('data-href','#popupWrite');

                } else {
                    // modify
                    //console.log("modify");

                    // 함수 추가 - 211207 
                    self.fileHideCheck();

                    if(self.$writePopup.hasClass='write') {
                        self.$writePopup.removeClass('write');
                    }

                    self.$writePopup.addClass(param.mode);
                    self.$writePopup.find('.pop-header > .tit > span').html("수정하기");

                    $(param.selector).attr('data-href','#popupWrite');

                    lgkorUI.requestAjaxData(ajaxUrl,{},function(result){

                        var data = result.data;

                        if(result.status === "success") {
                            var qTitle = data.questionTitle;
                            var qContent = data.questionContent;
                            var secretFlag = data.secret;
                            var qTypeCode = data.questionTypeCode;
                            var uploadfiles = data.files;

                            self.$writeTitle.val(qTitle);
                            self.$writeDesc.val(qContent);

                            if(secretFlag === "Y") {
                                self.$secretChkBtn.attr("checked", true);
                            }

                            for(var i=0 ; i < qTypeList.length; i++){
                                if(qTypeList[i].value === qTypeCode) {
                                    qTypeList[i].selected = true;
                                    qTypeBtnSelectedText.html(qTypeList[i].textContent);
                                }
                            }
                            // uploadFiles read.
                            for (var i in uploadfiles){
                                (function(i) {
                                    var k = uploadfiles[i].fileNo -1;

                                    var $fileBox = uploadInputFiles[k].closest('.file-item')
                                    var $filePreview = $fileBox.querySelector('.file-preview');
                                    var reader = new FileReader();
                                    if(uploadfiles[i]) {
                                        $.ajax({
                                            url: uploadfiles[i].filePath,
                                            xhrFields:{
                                                responseType: 'blob'
                                            },
                                            success: function(data){
                                                reader.readAsDataURL(data);
                                                reader.onload = function(e){
                                                    $fileBox.classList.add('on');
                                                    if(self.checkImgFileFormat(uploadfiles[i])) {
                                                        var imgTag = "<img src='" + e.target.result + "' alt='첨부파일 썸네일'>";
                                                        $filePreview.innerHTML = imgTag;
                                                    } else {
                                                        $fileBox.classList.add('is-video');
                                                    }
                                                }
                                            }
                                        });
                                    }
                                })(i);
                            }

                            if(uploadfiles.length == 4) {
                                self.$btnFileUpload.prop('disabled', true);
                            }
                        } else {
                            lgkorUI.alert("", {
                                title: "게시물 확인이 불가합니다. 관리자에게 문의해주세요. ",
                                ok : function(){
                                    self.$writePopup.vcModal('hide');
                                    location.reload();
                                }
                            }, param.selector); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        }
                    },"POST");
                }
                self.$writePopup.data("param", param);
                self.uploadFileChk(); //파일업로드 이벤트실행
            } else {
                lgkorUI.confirm('', {
                    title:'로그인 후 등록이 가능합니다.<br>로그인 하시겠습니까?',
                    okBtnName: '예',
                    cancelBtnName: '아니오',
                    ok : function (){
                        window.location.href = "/sso/member/login";
                    }
                }, param.selector); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
            }


        },
        // qna-write - post
        requestQnaWrite : function(el) {
            var self = this;
            var ajaxUrl = self.$writeForm.data('createAjax');

            //console.log("QnA 등록하기 - API request !!" + ajaxUrl);

            if(ajaxUrl) {
                var param = self.validation.getAllValues();
                var formData = new FormData();

                formData.append('modelId', self.$dataModelId);

                for (var key in param) {
                    if(key == 'privateFlag'){
                        param[key]  = param[key] == true ? "Y" : "N";
                    }
                    formData.append(key, param[key]);

                    if(key.indexOf('uploadFile') > -1) {

                        //신규 업로드시 삭제된 파일 체크
                        var $file = $("#"+key);
                        if(!param[key] &&  $file.data('fileFlag') === 'insert') {
                            $file.removeData('fileFlag')
                        }
                    }
                }

                lgkorUI.showLoading();

                lgkorUI.requestAjaxFileData(ajaxUrl, formData, function(result) {
                    if (result.status == 'success') {
                        lgkorUI.hideLoading();
                        lgkorUI.alert("", {
                            title: "게시물이 등록되었습니다.",
                            ok : function(){
                                self.$writePopup.vcModal('hide');
                                location.reload();
                            }
                        });

                    } else {
                        lgkorUI.hideLoading();
                        lgkorUI.alert("", {
                            title: "게시물 등록에 실패하였습니다. 입력한 내용을 확인해 주세요.",
                            ok : function(){

                            }
                        }, self.$writePopup.find('#content')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동

                    }
                }, 'POST', 'json',true, function(){
                    lgkorUI.hideLoading();
                    lgkorUI.alert("", {
                        title: "게시물 등록에 실패하였습니다.",
                        ok : function(){

                        }
                    }, self.$writePopup.find('.btn-confirm')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                });
            }
        },
        // qna-modify-popup - post
        requestQnaModify :function(el) {
            var self = this;
            var queNo = el.queNo;
            ajaxUrl = self.$writeForm.data('updateAjax');
            //console.log("QnA 수정하기 - API request !!" + ajaxUrl);

            if(ajaxUrl) {
                var param = self.validation.getAllValues();
                var formData = new FormData();

                // data modelId / data questionNo 값 추가
                formData.append('modelId', self.$dataModelId);
                formData.append('questionNo', queNo);


                for (var key in param) {
                    if(key == 'privateFlag'){
                        param[key]  = param[key] == true ? "Y" : "N";
                    }
                    formData.append(key, param[key]);

                    if(key.indexOf('uploadFile') > -1) {

                        var changeFile = key.replace('upload','change');

                        //신규 업로드시 삭제된 파일 체크
                        var $file = $("#"+key);
                        if(!param[key] &&  $file.data('fileFlag') === 'insert') {
                            $file.removeData('fileFlag');
                        }

                        //글작성 ,수정시 fileFlag 보내줌
                        formData.append(changeFile, $file.data('fileFlag'));
                    }
                }

                //lgkorUI.showLoading();
                lgkorUI.requestAjaxFileData(ajaxUrl, formData, function(result) {
                    if (result.status == 'success') {
                        lgkorUI.hideLoading();
                        lgkorUI.alert("", {
                            title: "게시물이 수정되었습니다.",
                            ok: function(){
                                self.$writePopup.vcModal('hide');
                                location.reload();
                            }
                        });
                    } else {
                        lgkorUI.hideLoading();
                        lgkorUI.alert("", {
                            title: "게시물 수정에 실패하였습니다. 입력한 내용을 확인해 주세요.",
                            ok : function(){

                            }
                        }, self.$writePopup.find('#content')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    }
                }, 'POST', 'json', true, function(){
                    lgkorUI.hideLoading();
                    lgkorUI.alert("", {
                        title: "게시물 수정에 실패하였습니다.",
                        ok : function(){

                        }
                    }, self.$writePopup.find('.btn-confirm')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                });
            }
        },
        // qna-delete-popup - post
        requestQnaDelete :function(param) {
            //console.log("QnA 삭제하기 - API request !!");
            var self = this;
            var ajaxUrl = self.$KRP0043.data('deleteAjax') + "?modelId=" + param.modelId +"&questionNo="+ param.queNo;
            if(lgkorUI.stringToBool(loginFlag)) {
                lgkorUI.requestAjaxData(ajaxUrl,param, function(result) {
                    if(result.status === 'success') {
                        lgkorUI.alert("", {
                            title: "게시물이 삭제되었습니다.",
                            ok: function(){
                                lgkorUI._historyBack();
                            }
                        });
                    } else {
                        lgkorUI.alert("", {
                            title: "게시물 삭제에 실패하였습니다.",
                            ok : function(){

                            }
                        }, self.$deleteBtn); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    }
                },"POST");
            } else {
                //비로그인
                lgkorUI.confirm('', {
                    title:'로그인 후 등록이 가능합니다.<br>로그인 하시겠습니까?',
                    okBtnName: '예',
                    cancelBtnName: '아니오',
                    ok : function (){
                        window.location.href = "/sso/member/login";
                    }
                }, self.$deleteBtn); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
            }

        },
        requestNoData : function() {
            var self = this;
            self.$KRP0043.find('.qna-result-lists').hide();
            self.$nodata.show();
            lgkorUI.hideLoading();
        },

        //파일업로드 체크
        uploadFileChk : function(){
            var self = this;

            vcui.require(['ui/validation', 'ui/imageVideoFileUpload', 'ui/formatter'], function () {
                self.$writeForm.find('.ui_imageinput').vcImageVideoFileUpload({
                    individualFlag: true,
                    format: 'jpg|jpeg|png|gif|mkv|mp4|m4v|flv|avi|wmv|mov',
                    totalSize: 800 * 1024 * 1024,
                    fileNameSize: 50, // 파일명 최대 50자 이내(.확장자 포함)
                    individual: {
                        size: 10 * 1024 * 1024
                    },
                    individualVideo: {
                        size: 200 * 1024 * 1024
                    },
                    message: {
                        name: '파일 명에 특수기호(? ! , . & ^ ~ )를 제거해 주시기 바랍니다.',
                        format: 'jpg, jpeg, png, gif, mkv, mp4, m4v, flv, avi, wmv, mov 파일만 첨부 가능합니다.',
                        size: '이미지 첨부파일 용량은 10MB 이내로 등록 가능합니다.',
                        videoSize: '동영상 첨부파일 용량은 200MB 이내로 등록 가능합니다.',
                        nameLength: '첨부파일 이름은 확장자 포함 50자 이내로 등록 가능합니다.'
                    },
                    delCompleted: function (target) {
                        if ($(target).hasClass('btn-del')) {
                            var $fileItem = $(target).closest('.file-item');

                            $fileItem.find("input[type='file']").data('fileFlag', 'delete');
                            $fileItem.find('.file-preview').empty();
                        }

                        if (self.$writeFormFileItem.not('.on').length) {
                            self.$btnFileUpload.prop('disabled', false);
                        } else {
                            self.$btnFileUpload.prop('disabled', true);
                        }
                    }
                });
            });
        },
        fileHideCheck : function() {
            var self = this;
            if(self.$writeFormFileItem.hasClass="on"){
                self.$writeFormFileItem.removeClass("on");
                self.$writeFormFileItem.find('.file-preview').empty();
                self.$writeFormFileItem.find('.file-name input').prop('placeholder','파일선택');
                self.$writeFormFileItem.find('.file-name input').val('');
            }

        },
        formValidationChk : function(param) {
            var self = this;
            var qnaTypeVal = self.$writePopup.find('.ui_selectbox').vcSelectbox('value');
            var titleVal = self.$writeTitle.val();
            var descVal = self.$writeDesc.val();

            if(!qnaTypeVal){
                lgkorUI.alert("", {
                    title: "문의 유형을 선택해주세요."
                }, self.$writePopup.find('.select-wrap .ui-select-button')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동

                return false;
            }

            if(!titleVal){
                lgkorUI.alert("", {
                    title: "문의 제목을 입력해주세요."
                }, self.$writeTitle); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동

                return false;
            }

            if(!descVal){
                lgkorUI.alert("", {
                    title: "문의 내용을 입력해주세요."
                }, self.$writeDesc); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동

                return false;
            }

            return true;
        }
    };

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'Q&A', name: 'KRP0043-2.0.0', fn: function () {
                KRP0043.init();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        KRP0043.init();
    })

})();